import React, { useEffect, useState } from "react";
import Fade from "@material-ui/core/Fade";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import Link from "@material-ui/core/Link";
import { makeStyles, Theme } from "@material-ui/core";
import { useTranslation } from "react-i18next";

export const useStyles = makeStyles((theme: Theme) =>({
  cookiesBox:{
     position: "fixed",
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: 2000,
      background: "rgb(230, 236, 240)",
      padding: "15px 30px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
  },
  cookiesLink:{
    color: "#A8005C", 
    fontWeight: 200, 
    paddingLeft: "5px", 
  },
}))

const CookiesConsent: React.FC = () => {
  const [t] = useTranslation();
  const classes = useStyles();
  const [showCookiesConsent, setShowCookiesConsent] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookiesConsent");
    setShowCookiesConsent(consent !== "accepted");
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookiesConsent", "accepted");
    setShowCookiesConsent(false);
  };

  if (!showCookiesConsent) return null;

  return (
    <Fade in timeout={1000}>
      <div className={classes.cookiesBox}>
        <Typography style={{ color: "#333333", fontSize: "18px", fontWeight: 200 }}>
           {t("cookiesConsent.message")}{"  "}
          <Link className={classes.cookiesLink} href="https://www.us.endress.com/en/endress-hauser-privacy-policy" target="_blank" rel="noopener noreferrer">
            {t("cookiesConsent.learnMore")}
          </Link>
        </Typography>
        <div style={{ display: "flex" }}>
          <Button variant="contained" color="primary" onClick={handleAccept}>
            {t("cookiesConsent.acceptBtn")}
          </Button>
        </div>
      </div>
    </Fade>
  );
};

export default CookiesConsent;